import { Scissors, StickyNote } from 'lucide-react';
import type { ExcerptKind } from '../../lib/excerpts';
import { useTaskStatus } from '../../lib/taskStatusCache';
import { TASK_ICONS, taskIconKind } from '../taskIcon';

/** An excerpt's kind icon; a task excerpt's follows its task's status (#324). */
export function ExcerptKindIcon({ kind, linkedId, size, className }: {
  kind: ExcerptKind; linkedId: string | null; size: number; className?: string;
}) {
  const status = useTaskStatus(kind === 'task' ? linkedId : null);
  if (kind === 'task') {
    const k = taskIconKind(status);
    const Icon = TASK_ICONS[k];
    return <Icon size={size} className={className} data-task-icon={k} />;
  }
  const Icon = kind === 'note' ? StickyNote : Scissors;
  return <Icon size={size} className={className} />;
}
